// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1e_ZX","icon":"SortAdornment_icon__puMYm","up":"SortAdornment_up__1O8Wc","down":"SortAdornment_down__jpnso","active":"SortAdornment_active__16S4N"};